import {
  requestNafath
} from "./chunk-AM6KDUML.mjs";

// src/hooks/wbk/nafath/send.ts
import { useMutation } from "@tanstack/react-query";
var useRequestNafath = () => {
  return useMutation({
    mutationFn: requestNafath
  });
};

export {
  useRequestNafath
};
//# sourceMappingURL=chunk-ULAZCJCA.mjs.map